import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCaretRightStopIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 13.5 14.5",
	style: { enableBackground: "new 0 0 13.5 14.5" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.caret-right-stop-st1{fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n	.caret-right-stop-st2{fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;}\n"
	}), /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
		className: "caret-right-stop-st1",
		d: "M1,13.5l6.3-6.3L1,1"
	}), /* @__PURE__ */ _jsx("line", {
		className: "caret-right-stop-st2",
		x1: 12.5,
		y1: 1.2,
		x2: 12.5,
		y2: 13.2
	})] })]
});
export default SvgCaretRightStopIcon;
